import styled from 'styled-components';
import { ReactComponent as Close } from 'styles/icons/close.svg';
import { normalize } from 'utils/styles';

export const CloseModalIcon = styled(Close)`
  cursor: pointer;
  height: ${normalize('18px')};
  position: absolute;
  top: ${normalize('20px')};
  right: ${normalize('32px')};
  width: ${normalize('18px')};
`;
